import React from 'react'
import { Navigate, useLocation } from 'react-router-dom'
import { useAuth } from '../context/AuthContext'

const GuestRoute = ({ children }) => {
    const { isAuthenticated } = useAuth()
    const location = useLocation()

    if (isAuthenticated) {
        const redirectTo = location.state?.from?.pathname || '/dashboard'
        return <Navigate to={redirectTo} replace />
    }

    return children
}

export default GuestRoute
